
import { useMemo } from "react";
import { minutesToHHMM, HHMMToMinutes } from "../utils/helpers";
import { theme } from "../utils/theme";

const C = theme.dark;

export default function TimelineView({ logs, categories, date }) {
  const timelineLogs = useMemo(() => {
    const sorted = [...logs].sort((a, b) => HHMMToMinutes(a.startTime) - HHMMToMinutes(b.startTime));
    const rows = []; // Each row is an array of logs that don't overlap

    sorted.forEach(log => {
      const start = HHMMToMinutes(log.startTime);
      
      let placed = false;
      for (let i = 0; i < rows.length; i++) {
        const lastInRow = rows[i][rows[i].length - 1];
        if (HHMMToMinutes(lastInRow.endTime) <= start) {
          rows[i].push(log);
          placed = true;
          break;
        }
      }
      if (!placed) {
        rows.push([log]);
      }
    });

    return rows;
  }, [logs]);

  const hours = Array.from({ length: 25 }, (_, i) => i);

  return (
    <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "20px", position: "relative", overflowX: "auto", marginBottom: 20 }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: C.text, marginBottom: 16 }}>Activity Timeline - {date}</div>
      <div style={{ minWidth: 600 }}>
        {/* Timeline Axis */}
        <div style={{ display: "flex", borderBottom: `1px solid ${C.border}`, paddingBottom: 10, marginBottom: 20 }}>
          {hours.map(h => (
            <div key={h} style={{ flex: 1, textAlign: "left", fontSize: 10, color: C.muted, borderLeft: `1px solid ${C.dim}`, paddingLeft: 4, height: 10 }}>
              {String(h).padStart(2, "0")}
            </div>
          ))}
        </div>

        {/* Timeline Grid Background */}
        <div style={{ position: "relative", minHeight: Math.max(100, timelineLogs.length * 40 + 20) }}>
          {hours.map(h => (
            <div key={h} style={{ position: "absolute", left: `${(h / 24) * 100}%`, top: 0, bottom: 0, width: 1, background: C.dim, opacity: 0.3, zIndex: 0 }} />
          ))}

          {/* Bars */}
          {timelineLogs.map((row, rowIndex) => (
            <div key={rowIndex} style={{ position: "relative", height: 30, marginBottom: 8 }}>
              {row.map(log => {
                const startMin = HHMMToMinutes(log.startTime);
                const endMin = HHMMToMinutes(log.endTime);
                const left = (startMin / 1440) * 100;
                const width = ((endMin - startMin) / 1440) * 100;
                const cat = categories.find(c => c.id === log.category);
                const color = cat?.color || C.accent;

                return (
                  <div 
                    key={log.entryId}
                    title={`${log.topicName} (${log.startTime} - ${log.endTime})`}
                    style={{ 
                      position: "absolute", 
                      left: `${left}%`, 
                      width: `${width}%`, 
                      height: "100%", 
                      background: color, 
                      borderRadius: 4, 
                      border: "1px solid rgba(0,0,0,0.1)",
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: 9,
                      fontWeight: 600,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      padding: "0 4px",
                      zIndex: 1,
                    }}
                  >
                    {log.topicName}
                  </div>
                );
              })}
            </div>
          ))}

          {logs.length === 0 && (
            <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", color: C.muted, fontSize: 13 }}>
              No logs recorded for this day.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
